<div>
  <div icon>
    <i class="{{icon}}" style="width: {{size}}px; height: {{size}}px; line-height: {{size}}px; font-size: {{size * 0.8}}px" (click)="clickIcon.emit($event)"></i>
    <ng-content select="[overlay]"></ng-content>
  </div>
  <div content>
    <ng-content></ng-content>
  </div>
</div>
